import request from '../utils/request';

export function fetchIdentifications(query) {
    return request({
      url: '/LabIdentifications',
      method: 'get',
    });
  }
